import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import PostCard from "../components/PostCard";
import Sidebar from "../components/Sidebar";
import { searchPosts } from "../data/posts";

function Search() {
  const [params, setParams] = useSearchParams();
  const query = params.get("q") || "";
  const [input, setInput] = useState(query);
  useEffect(() => setInput(query), [query]);

  const results = searchPosts(query);

  const submit = (e) => {
    e.preventDefault();
    setParams(input.trim() ? { q: input.trim() } : {});
  };

  return (
    <Container className="py-4">
      <Row className="g-4">
        <Col lg={8}>
          <h2 className="block-title">Search Results</h2>

          <Form onSubmit={submit} className="top-search mb-4" style={{ maxWidth: 480 }}>
            <InputGroup>
              <Form.Control
                placeholder="Search posts…"
                value={input}
                onChange={(e) => setInput(e.target.value)}
              />
              <Button type="submit"><FaSearch /></Button>
            </InputGroup>
          </Form>

          {query && (
            <p className="text-muted-2">
              {results.length} result{results.length !== 1 ? "s" : ""} for{" "}
              <strong>"{query}"</strong>
            </p>
          )}

          {query && results.length === 0 && (
            <div className="widget"><div className="widget-body text-center py-4">
              <div className="fs-1 mb-2">🔍</div>
              <p className="mb-0 text-muted-2">No posts found. Try "games", "free fire" or "ai".</p>
            </div></div>
          )}

          <Row className="g-4">
            {results.map((p) => (
              <Col md={6} key={p.id}>
                <PostCard post={p} />
              </Col>
            ))}
          </Row>
        </Col>
        <Col lg={4}>
          <Sidebar />
        </Col>
      </Row>
    </Container>
  );
}

export default Search;
